module.exports = __webpack_public_path__ + "img/hero.b60dfde2.jpg";